import { apiUrl, axiosInstance } from "hooks/axiosinstance"

export const fetchUserReportTable = async (page, limit, payload) => {
    return await axiosInstance.post(`${apiUrl}/user/verification/report?page=${page}&limit=${limit}`, payload);
}

export const fetchUserReportStats = async (payload) => {
    return await axiosInstance.post(`${apiUrl}/user/verification/report-stats`, payload);
}